/** 规范化导出参数，避免 click Event 被当成 options */
export function normalizeExportOptions(options) {
  if (
    !options ||
    typeof options !== 'object' ||
    options instanceof Event ||
    options.isTrusted === true
  ) {
    return {};
  }
  return options;
}

/** 枚举 yyyy-MM 闭区间月份，如 2026-01 ~ 2026-05 */
export function enumerateMonths(start, end) {
  if (!start || !end) return [];
  const startParts = String(start).split('-').map(Number);
  const endParts = String(end).split('-').map(Number);
  if (startParts.length < 2 || endParts.length < 2) return [];

  let year = startParts[0];
  let month = startParts[1];
  const endYear = endParts[0];
  const endMonth = endParts[1];
  if (!year || !month || !endYear || !endMonth) return [];

  const months = [];
  while (year < endYear || (year === endYear && month <= endMonth)) {
    months.push(`${year}-${String(month).padStart(2, '0')}`);
    month += 1;
    if (month > 12) {
      month = 1;
      year += 1;
    }
    // 防止异常死循环
    if (months.length > 240) break;
  }
  return months;
}

export function omitEmptyParams(params) {
  const next = { ...params };
  Object.keys(next).forEach((key) => {
    if (next[key] === '' || next[key] === null || next[key] === undefined) {
      delete next[key];
    }
  });
  return next;
}
